/**
 * Firebase メールアクションの自前受け口。
 *
 * Firebase Console の「アクション URL」をこのパスへ向けることで、
 * 英語固定の `/__/auth/action` を日本語ページへ置き換える。
 * `router.js` から `...authActionRoutes(SITE_TITLE)` で展開する。
 */

import type { RouteConfig } from 'vue-router'
import { AUTH_ACTION_PATH } from '@/utils/auth/authAction'

export function authActionRoutes(siteTitle: string): RouteConfig[] {
  return [
    {
      path: AUTH_ACTION_PATH,
      component: () => import('@/views/pages/auth/AuthAction.vue'),
      name: 'authAction',
      // 検索結果に載せない（robots meta は AuthAction.vue 側で付ける）ため
      // description は持たせない。canonical は自己参照で足りる。
      meta: {
        title: `メールアドレスの確認 - ${siteTitle}`,
        linkformat: 6
      }
    }
  ]
}
